/* The values a restriction context resolves to once a failed push is accounted for.
   Every consumer (table cells, tooltips, the day-override-modal) reads these instead
   of combining the raw PMS, override and recommendation values itself, so a failed
   push is handled the same way everywhere. */
export interface RestrictionValues {
  hasFailedPush: boolean;
  /* What is in place. A failed push leaves nothing new in the PMS, so the PMS value
     is in effect. Otherwise the override wins, then the recommendation (what
     autopilot pushes next), then the PMS value. */
  inEffectValue: number | null;
  /* Whether to show the override indicator. A failed push leaves its override in
     place (the BE keeps it active), but it never reached the PMS, so it is not shown
     as applied. Send and delete logic reads the override record instead, so turning
     automation back on still deletes the failed override. */
  showOverride: boolean;
}

interface RestrictionValuesOptions {
  hasFailedPush: boolean;
  override: { value: number } | null | undefined;
  pmsValue: number | null | undefined;
  recommendedValue: number | null | undefined;
}

export function resolveRestrictionValues({
  hasFailedPush,
  override,
  pmsValue,
  recommendedValue,
}: RestrictionValuesOptions): RestrictionValues {
  return {
    hasFailedPush,
    inEffectValue: hasFailedPush
      ? (pmsValue ?? null)
      : (override?.value ?? recommendedValue ?? pmsValue ?? null),
    showOverride: override != null && !hasFailedPush,
  };
}
